var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuoteWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 31",
    style: {
      enableBackground: "new 0 0 36 31"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,13.7V3.3C0,1.5,1.5,0,3.4,0h10.5c1.2,0,2.3,0.5,3.2,1.3l11.8,11.6c1.8,1.7,1.8,4.5,0,6.3l-9.4,9.2 c-1.8,1.7-4.6,1.7-6.4,0L1.3,16.8C0.5,16,0,14.8,0,13.7z M10.1,7.7c0-1.2-1-2.2-2.2-2.2s-2.2,1-2.2,2.2s1,2.2,2.2,2.2 S10.1,9,10.1,7.7z M24.3,0.5l9,8.9c3.7,3.7,3.7,9.6,0,13.2l-7.9,7.8c-0.7,0.7-1.7,0.7-2.4,0c-0.7-0.6-0.7-1.7,0-2.3l7.9-7.8 c2.4-2.4,2.4-6.2,0-8.6l-9-8.9c-0.7-0.7-0.6-1.7,0-2.3C22.5-0.2,23.6-0.2,24.3,0.5L24.3,0.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteWhite);
export default __webpack_public_path__ + "static/media/Quote_White.813a4876b6e6ba8a6287be5e31a12905.svg";
export { ForwardRef as ReactComponent };